import React from 'react';
import graphql from "babel-plugin-relay/macro";
import NewModal from "../../../components/common/modals/NewModal";
import {
    createOptions,
    yesNoUnknownOptions
} from "../../../helpers/utils";
import {useFragment} from "react-relay";
import {facilitiesDropdown} from "../../facilities/FacilityFragments";
import * as yup from "yup";
import {useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import HorizontalFormSelect from "../../../components/common/horizontal-form-inputs/HorizontalFormSelect";
import {contractLineOfService} from "../../contracts/ContractLineOfService/ContractLinesOfServiceFragments";
import HorizontalFormCheck from "../../../components/common/horizontal-form-inputs/HorizontalFormCheck";
import HorizontalFormDate from "../../../components/common/horizontal-form-inputs/HorizontalFormDate";
import {bandedSchema, newBandDefaultValues} from "../../../helpers/bandedUtils";

const NewLocationFacilityModal = ({showModal, onClose, allFacilities, locationId, availableLinesOfService}) => {
    const mutation = graphql`
        mutation NewLocationFacilityModalMutation($facilityId: ID!, $locationId: ID!, $showInDirectory: Boolean!,
         $legalContractLineOfServiceId: ID!, 
       $acceptingNewPatients: YesNoUnknown!, $providesTelehealth: YesNoUnknown!, $providesOfficeVisits: YesNoUnknown!,
            $providesHomeVisits: YesNoUnknown!, $effectiveFrom: DateOnly!, $effectiveTo: DateOnly!) {
            facilityLocation {
                create(input: {facilityId: $facilityId, locationId: $locationId, showInDirectory: $showInDirectory,
                legalContractLineOfServiceId: $legalContractLineOfServiceId,
                acceptingNewPatients: $acceptingNewPatients, providesTelehealth: $providesTelehealth, providesOfficeVisits: $providesOfficeVisits,
                providesHomeVisits: $providesHomeVisits,effectiveFrom: $effectiveFrom, effectiveTo: $effectiveTo}) {
                    facilityLocation {
                        id
                    }
                }
            }
        }`
    const facilities = createOptions(useFragment(facilitiesDropdown, allFacilities), "id", "applicableVersion.displayName");
    const linesOfService = useFragment(contractLineOfService, availableLinesOfService);
    const legalContractLineOfServiceOptions = createOptions(linesOfService, "id", "lineOfService.name");
    const defaultValues = {
        ...newBandDefaultValues,
        facilityId: '',
        locationId: locationId,
        legalContractLineOfServiceId: '',
        showInDirectory: true
    }
    const schema = bandedSchema.shape({
        facilityId: yup.string().required("Facility is required"),
        legalContractLineOfServiceId: yup.string().required("Line of service is required"),
        showInDirectory: yup.boolean().required("Show in Directory is required"),
        acceptingNewPatients: yup.string().required("Accepting New Patients is required"),
        providesTelehealth: yup.string().required("Provides Telehealth is required"),
        providesHomeVisits: yup.string().required("Provides Home Visits is required"),
        providesOfficeVisits: yup.string().required("Provides Office Visits is required")
    });
    const methods = useForm({defaultValues: defaultValues, resolver: yupResolver(schema)});
    return (
        <NewModal showModal={showModal}
                  onClose={onClose}
                  mutation={mutation}
                  methods={methods}
                  title={"New Facility Location"}
                  returnedIdKey={"facilityLocation.create.facilityLocation.id"}
                  redirectUrl={"/facility-locations/"}
        >
            <HorizontalFormSelect options={facilities} controlId={"facilityId"} label={"Facility"} />
            <HorizontalFormSelect options={legalContractLineOfServiceOptions} controlId={"legalContractLineOfServiceId"} label={"Line of Service"} />
            <HorizontalFormCheck controlId={"showInDirectory"} label={"Show In Directory?"} />
            <HorizontalFormSelect options={yesNoUnknownOptions} controlId={"acceptingNewPatients"} label={"Accepting New Patients?"} />
            <HorizontalFormSelect options={yesNoUnknownOptions} controlId={"providesTelehealth"} label={"Provides Telehealth?"} />
            <HorizontalFormSelect options={yesNoUnknownOptions} controlId={"providesOfficeVisits"} label={"Provides Office Visits?"} />
            <HorizontalFormSelect options={yesNoUnknownOptions} controlId={"providesHomeVisits"} label={"Provides Home Visits?"} />
            <HorizontalFormDate controlId={"effectiveFrom"} label={"Effective From"} />
            <HorizontalFormDate controlId={"effectiveTo"} label={"Effective To"} />

        </NewModal>
    )
}
export default NewLocationFacilityModal